import React, { useState } from 'react';
import moment from 'moment';
import { Activities, } from 'src/types/dealInsights';
import styles from './styles.module.scss';
import cx from 'classnames';
import Text from 'src/components/text';
import DOMPurify from 'dompurify';
import Tooltip from "src/components/tooltip";
import { activityIconMap } from 'src/utils/dealInsights.helper';

const DefaultUserAvatar = '/images/default_user_profile_background.png';

interface EmailProps {
  body: string,
}

const formatDuration = (ms: number | null) => {
  if (!ms) return '';

  const d = moment.duration(ms);

  const minutes = Math.floor(d.asMinutes());
  const seconds = d.seconds();

  if (minutes > 0 && seconds > 0) {
    return `${minutes}mins ${seconds}s`;
  }

  if (minutes > 0) {
    return `${minutes}mins`;
  }

  return `${seconds}s`;
};

const EmailCard = ({ body }: EmailProps) => {
  if (!body) return <></>;
  return (
    <div className={styles.detailedContainer}>
      {/* <div className={styles.pillsRow}> */}
      {/* // <div className={styles.pill}>
          //   <span className={styles.pillLabel}>From:</span> {details.from}
          // </div> */}

      {/* //<div className={styles.pill}>
            <span className={styles.pillLabel}>To:</span> {details.to}
          </div> */}
      {/* </div> */}
      <div dangerouslySetInnerHTML={{ __html: body || '' }} className={styles.emailBody} />
    </div>
  );
};

interface CallProps {
  body: string,
  duration?: number | null,
}

const CallCard = ({ body, duration }: CallProps) => {
  if (!body) return <></>;
  return (
    <div className={styles.detailedContainer}>
      {duration && <div className={styles.pillsRow}>
        <div className={styles.pill}>
          <i className="paperflite-clock" /> <span className={styles.pillLabel}>Duration:</span> {formatDuration(duration)}
        </div>
        {/* <div className={styles.pill}>
            <i className="paperflite-user-settings" /> <span className={styles.pillLabel}>prospect:</span> {details.prospects.join(', ')}
          </div> */}
      </div>}

      <div dangerouslySetInnerHTML={{ __html: body || '' }} className={styles.bodyText} />
    </div>
  );
};

interface DefaultDescriptionProps {
  text?: string;
}

const DefaultDescription = ({ text, }: DefaultDescriptionProps) => {
  return (
    <div className={styles.defaultDescContainer}>
      <div dangerouslySetInnerHTML={{ __html: text || '' }} className={styles.desc} />
    </div>
  );
};

const InfoCard = ({ label, value, icon }: {
  label: string;
  value: string;
  icon?: boolean;
}) => {
  return (
    <div className={styles.infoCard}>
      <p className={styles.label}>{label}:</p>
      <div className={styles.content}>
        {icon && <img src={DefaultUserAvatar} className={styles.avatar} />}
        <div className={styles.value}>
          <Text text={value} tooltip={{ placement: "auto" }} />
        </div>
      </div>
    </div>
  )
}

interface ActivityRowProps {
  activity: Activities;
  isDetailedView: boolean;
}

export const ActivityRow = ({ activity, isDetailedView }: ActivityRowProps) => {
  const iconClass = activityIconMap[activity.activityType] || 'paperflite-tick-unselected'; // icon mapped.

  const renderDetailedActivityContent = () => {
    switch (activity.activityType) {
      case 'EMAIL':
        return (
          <EmailCard body={activity.body} />
        );
      case 'CALL':
      case 'MEETING':
        return (
          <CallCard duration={activity.durationMs} body={activity.body} />
        );
      default:
        return <DefaultDescription text={activity.body} />
    }
  };


  const renderNormalActivityContent = () => {
    switch (activity.activityType) {
      case 'EMAIL':
        return (
          <div className={styles.infoWrapper}>
            <InfoCard label={'Sales Rep'} value={activity.ownerName || '-'} icon />
          </div>
        );
      case 'CALL':
      case 'MEETING':
        return (
          <div className={styles.infoWrapper}>
            <InfoCard label={'Sales Rep'} value={activity.ownerName || '-'} icon />
            <InfoCard label={'Durations'} value={activity.durationMs ? formatDuration(activity.durationMs) : '-'} />
          </div>
        );
      default:
        return (
          <div className={styles.infoWrapper}>
            <InfoCard label={'Sales Rep'} value={activity.ownerName || '-'} icon />
            <InfoCard label={'Deal Value'} value={activity.dealValue ? `$${activity.dealValue}` : '-'} />
          </div>
        )
    }
  }

  const extractText = (html: string): string => {
    if (!html) return '';
    const clean = DOMPurify.sanitize(html);
    const temp = document.createElement('div');
    temp.innerHTML = clean;
    return temp.innerText.trim();
  };

  return (
    <div className={styles.activityRow}>
      <div className={styles.timelineGutter}>

        <Tooltip content={activity.title} placement='left'>
          <div className={cx(styles.icon)}>
            <i className={iconClass} />
          </div>
        </Tooltip>

        <div className={styles.verticalLine} />
      </div>

      {isDetailedView ?
        <div className={styles.deatiledViewArea}>
          <div className={styles.header}>
            {/* <div className={styles.title}>
              <Text text={extractText(activity.subject)} tooltip={{ placement: "auto" }} />
            </div> */}
            <p className={styles.title}>{extractText(activity.subject)}</p>
            <p className={styles.timestamp}>{activity.occurredAt ? moment(activity.occurredAt).format("DD MMM'YY, hh:mm A") : ''}</p>
          </div>
          {renderDetailedActivityContent()}
        </div> :
        <div className={styles.normalViewArea}>
          <div className={styles.header}>
            <div className={styles.title}>
              <Text text={extractText(activity.subject)} tooltip={{ placement: "auto" }} />
            </div>
            <p className={styles.timestamp}>{activity.occurredAt ? moment(activity.occurredAt).format("hh:mm A") : ''}</p>
          </div>
          <div className={styles.details}>
            <div dangerouslySetInnerHTML={{ __html: activity.body || '' }} className={styles.body} />
            {renderNormalActivityContent()}
          </div>
        </div>}
    </div>
  );
};

// Placeholder
export const DetailedViewPlaceHolder = () => {
  return (
    <div className={styles.activityRow}>
      <div className={styles.timelineGutter}>
        <div className={cx(styles.icon, styles.skeletonIcon)} />
        <div className={styles.verticalLine} />
      </div>

      <div className={styles.deatiledViewArea}>
        <div className={styles.header}>
          <div className={cx(styles.skeletonText, styles.skeletonTitle)} />
          <div className={cx(styles.skeletonText, styles.skeletonTime)} />
        </div>
        <div className={cx(styles.detailedContainer, styles.skeletonBox)}>
          <div className={cx(styles.skeletonText, styles.skeletonLine)} />
          <div className={cx(styles.skeletonText, styles.skeletonLine, styles.w75)} />
          <div className={cx(styles.skeletonText, styles.skeletonLine, styles.w50)} />
        </div>
      </div>
    </div>
  );
};

export const NormalViewPlaceHolder = () => {
  return (
    <div className={cx(styles.activityRow)}>
      <div className={styles.timelineGutter}>
        <div className={cx(styles.icon, styles.skeletonIcon)} />
        <div className={styles.verticalLine} />
      </div>

      <div className={styles.normalViewArea}>
        <div className={styles.header}>
          <div className={cx(styles.skeletonText, styles.skeletonTitle)} />
          <div className={cx(styles.skeletonText, styles.skeletonTime)} />
        </div>
        <div className={cx(styles.details, styles.skeletonBox)}>
          <div className={cx(styles.skeletonText, styles.skeletonLine)} />
          <div className={cx(styles.skeletonText, styles.skeletonLine, styles.w75)} />
          <div className={cx(styles.skeletonText, styles.skeletonLine, styles.w50)} />
        </div>
      </div>
    </div>
  );
};
